import React from 'react';
import Image from 'next/image';
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import BookOnline from '@common/buttons/BookOnline';
import Link from 'next/link';
import { company } from '@components/config/Company';
function AboutUs() {
  return (
    <div>
      <div className="bg-secondary py-9">
        <div className="font-light text-center text-xl sm:text-2xl xl:text-4xl">
          About <b>24/7 Radio Carz</b>
        </div>
        <div className="font-light text-center text-3xl">
          Birmingham’s Largest Private Hire Taxi Company
        </div>
      </div>
      <div className="my-10 paddingClass">
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3 lg:gap-5 ">
          <div className="col-span-1 lg:col-span-2">
            <div className="relative w-full h-40">
              <Image
                alt="Birmingham Picture"
                layout="fill"
                src="/assets/images/aboutUs.jpeg"
              />
            </div>
            <div className=" leading-8 text-justify my-5 lg:w-[90%] w-[100%]">
              At 247 Radio Cars, we are proud of the quality of service that our
              customers receive. Our dedicated and professional drivers ensure
              you arrive safely and on time at your destination, while our
              modern fleet provides a comfortable ride all around Birmingham.
              <br />
              Moreover, our friendly customer support team can always answer any
              questions or concerns. <br /> We have a mixed fleet that includes
              clean everyday cars and mini-buses. We also offer luxury cars that
              include Mercedes E class, Volvo SE Executive, BMW 5 and 7 series
              cars and Mercedes Minibuses, which seat from 8 up to 17 people.{' '}
              <br />
              <h3 className="mt-3 font-bold">Area We Cover</h3>
              We have booking offices in Solihull, Sandwell that are fully
              operational 24 Hours a day, 365 days a year, taking over 200,000
              bookings per month! 24-7 Cars constantly invest in new ways to
              improve the customer booking experience. As well as the
              traditional method of picking up the phone, you can book your car
              online, using our automated answering service & now you book your
              car in under 5 seconds using our state-of-the-art&nbsp;
              <a
                href="https://apps.apple.com/gb/app/247-carz/id1241258685"
                target="_blank"
                alt="AppStore Icon"
              >
                <span className="font-bold cursor-pointer text-secondary">
                  iPhone
                </span>
              </a>
              &nbsp;&&nbsp;
              <a
                href="https://play.google.com/store/apps/details?id=uk.riide.twofourseven&hl=en"
                target="_blank"
                alt="PlayStore Icon"
              >
                <span className="font-bold cursor-pointer text-secondary">
                  Android
                </span>
              </a>
              &nbsp;app. <br />
              <br />
              Our friendly and helpful drivers will get you to your desired
              destination on time - at the best price possible.
              <p>
                At 247 Radio Cars, we're always looking for ways to improve our
                service and make your journey as comfortable as possible. We're
                proud to offer a car service that is 'at your service' 24/7, and
                we'll do everything we can to make sure your journey is smooth
                and stress-free. Thank you for choosing 247 Radio Cars!
              </p>
              <h3 className="mt-3 font-bold">Our Mission and Vision</h3>
              <p>
                We're steadfast in our commitment to providing you with the
                highest standards of service. We guarantee that no matter where
                your journey takes you and whatever time it is, booking with us
                will always be one of life's great constants - without cost
                fluctuations or surge charges at peak times. <br />
                <br /> Our impressive 98% on-time rate and an average 10 minutes
                pick up time are further proof that when it comes to traveling
                safely and securely, there really isn't a better option! With
                cash payments accepted alongside card transactions as well as
                Priority Business or Personal Accounts available too – why go
                anywhere else?
              </p>
              <br />
              To back up our commitment to quality, we have a growing number of:
              <ul className="list-disc">
                <li>Prompt and courteous drivers</li>
                <li>Clean and comfortable vehicles</li>
                <li>Quick response times</li>
                <li>Safe and reliable service - Friendly customer support</li>
                <li>Affordable rates</li>
                <li>
                  Convenient
                  <Link href={'/'}>
                    <a className="mx-2 text-secondary font-bold hover:underline">
                      online
                    </a>
                  </Link>
                  booking system
                </li>
                <li>Real-time tracking for all rides</li>
                <li>Variety of payment methods accepted</li>
                <li>Transparent billing</li>
              </ul>
              Customers who have used 247 Radio Cars for their transportation
              needs in Birmingham have had nothing but positive experiences.
              <a
                href="https://www.google.com/maps/place/247+Radio+Carz/@52.4452678,-1.8158432,17z/data=!4m8!3m7!1s0x4870ba3070609dd1:0xe2afbc05b28d7d5d!8m2!3d52.4452678!4d-1.8158432!9m1!1b1!16s%2Fg%2F1hc165p39?entry=ttu"
                className="mx-2 text-secondary font-bold hover:underline"
                target="_blank"
              >
                Reviews on Google
              </a>
              praise the company's prompt and courteous drivers, clean and
              comfortable vehicles, quick response times, and safe and reliable
              service. Customers also appreciate the friendly customer support
              team,
            </div>
          </div>
          <div className="flex flex-col items-center justify-center px-5 py-10 bg-primary">
            <LocalTaxiIcon className="text-7xl text-secondary" />

            <div className="my-10 font-light text-center text-base lg:text-xl text-white">
              Book online or call us today on
              <Link href={`tel:${company[0]?.tel_number}`}>
                <a className="mx-2 text-secondary hover:underline">
                  {company[0]?.tel_number}
                </a>
              </Link>
              or
              <Link href={`tel:${company[0]?.tel_number_two}`}>
                <a className="mx-2 text-secondary hover:underline">
                  {company[0]?.tel_number_two}
                </a>
              </Link>{' '}
              for the best airport transfers price.
            </div>
            <BookOnline />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
